'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
import Divider from '@mui/material/Divider';
import { headerCssClassNames } from './headerCssClassNames';
const StyledDivider = styled(Divider)(({ theme }) => ({
    height: '24px',
    marginTop: 'auto',
    marginBottom: 'auto',
    borderColor: theme.tokens.FuelColorBorderBase
}));
export const HeaderDivider = forwardRef((props, ref) => (_jsx(StyledDivider, { ...props, className: headerCssClassNames.divider, flexItem: true, orientation: 'vertical', ref: ref })));
HeaderDivider.displayName = 'HeaderDivider';
